import { wpAjaxFetch } from "../../helpers/customFetch";

document.addEventListener("DOMContentLoaded", () => {
  const tabs = document.querySelectorAll(".tabs-faculties__li");
  const postsContainer = document.getElementById("tabs-faculties-content");
  const headingTitle = document.getElementById("tabs-heading-title");
  const headingDescription = document.getElementById(
    "tabs-heading-description"
  );
  const loader = document.getElementById("tabs-loader");

  if (
    !tabs.length ||
    !postsContainer ||
    !headingTitle ||
    !headingDescription ||
    !loader
  ) {
    console.warn(
      "Algunos elementos necesarios para las tabs no están presentes en el DOM."
    );
    return;
  }

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      tabs.forEach((t) => t.classList.remove("isActive"));
      tab.classList.add("isActive");

      const termId = tab.dataset.termId;
      const taxonomy = tab.dataset.taxonomy;
      const title = tab.dataset.title;
      const description = tab.dataset.description;

      headingTitle.textContent = title || "";
      headingDescription.textContent = description || "";

      loader.style.display = "block";
      postsContainer.querySelector(".tabs-faculties__posts")?.remove();

      wpAjaxFetch(
        "load_faculties_posts",
        {
          term_id: termId,
          taxonomy: taxonomy,
        },
        false
      )
        .then((res) => res.text())
        .then((html) => {
          loader.style.display = "none";
          postsContainer.insertAdjacentHTML("beforeend", html);
        })
        .catch((err) => {
          console.error("Error al cargar contenido vía AJAX:", err);
          loader.innerHTML = "<p>Error al cargar datos.</p>";
        });
    });
  });
});
